module.exports = __webpack_public_path__ + "img/logo.665433ad.png";